import { Panel, Label } from '@uhg-harmony/uitk-react';
import { Arrow } from 'builder/scenes/SiteBuilder/SettingsPanel/SettingsPanel';
import {
  SizeLocationData,
  WidgetSizeLocation,
} from '../../../../builder/components/WidgetSizeLocation';
import { Config } from './types';
import { Border } from 'builder/components/WidgetConfigurations/Border';
import {
  SizeLocationPanel,
  StyledPanel,
  StyledPanelTitle,
} from '../../Text/TextWidgetControl';
import DropdownPanel from 'builder/components/WidgetConfigurations/Dropdown/DropdownPanel';
import styled from 'styled-components';

const DropdownPanelWrapper = styled(StyledPanel)`
  & button[class^='Panelcomponent__HeaderSection'] {
    height: 2.5em;
    background: rgba(141, 145, 160, 0.07);
    border-radius: 0;
    &: hover,&: focus {
      box-shadow: none;
    }
  }
  & span[class^='Panelcomponent__HeaderMainContent'] {
    height: 2.5em;
  }
  & div[class^='uitk-panel Panelcomponent__Panel'] {
    margin-bottom: 0rem;
    border: none;
  }
  & div[class^='Panelcomponent__Content'] {
    padding: 1rem 2rem 1rem 1rem;
  }
`;

const DropdownWidgetControl: React.FC<WidgetControlProps<Config>> = (
  props: WidgetControlProps<Config>
) => {
  const {
    value,
    onChange,
    widgetState,
    currentPage: { layoutLocked },
  } = props;

  const updateWidgetSizeLocation = (sizeLoc: SizeLocationData) => {
    onChange({
      ...value,
      width: sizeLoc.width,
      height: sizeLoc.height,
      xLocation: sizeLoc.xLocation,
      yLocation: sizeLoc.yLocation,
      uniqueId: sizeLoc.uniqueId,
    });
  };

  const updateBorderData = (data: BorderData) => {
    onChange({
      ...value,
      borderData: data,
    });
  };

  const handleLineColor = (data: string) => {
    onChange({
      ...value,
      lineColor: data,
    });
  };

  const handleFieldRequirement = (data: boolean) => {
    onChange({
      ...value,
      required: data,
    });
  };

  const handleFieldLabel = (data: string) => {
    onChange({
      ...value,
      label: data,
    });
  };

  const handleSelectValues = (data: string) => {
    onChange({
      ...value,
      value: data,
    });
  };

  const handleDropdownIconColor = (data: string) => {
    onChange({
      ...value,
      buttonColor: data,
    });
  };

  return (
    <>
      <Panel.Group>
        <DropdownPanelWrapper>
          <Panel
            title={<Label style={StyledPanelTitle}>General</Label>}
            icon={Arrow}
            data-test-id="Dropdown-general-panel"
          >
            <DropdownPanel
              data-test-id="dropdown-panel"
              disabled={layoutLocked}
              handleFieldRequirement={handleFieldRequirement}
              handleFieldLabel={handleFieldLabel}
              handleSelectValues={handleSelectValues}
              handleIconColor={handleDropdownIconColor}
              widgetState={widgetState}
              pages={props.pages}
              site={props.site}
              updateSite={props.updateSite}
              saveSite={props.saveSite}
            />
          </Panel>
        </DropdownPanelWrapper>
        <StyledPanel>
          <SizeLocationPanel
            title={<Label style={StyledPanelTitle}>Size and Location</Label>}
            initiallyClosed
            icon={Arrow}
            data-test-id="authentication-panel"
          >
            <WidgetSizeLocation
              data-test-id="widget-size-location"
              disabled={layoutLocked}
              sizeLocation={{
                xLocation: value.xLocation,
                yLocation: value.yLocation,
                width: value.width,
                height: value.height,
                uniqueId: value.uniqueId,
              }}
              updateWidgetSizeLocation={updateWidgetSizeLocation}
              activeWidgetId={widgetState.id}
            />
          </SizeLocationPanel>
        </StyledPanel>
        <StyledPanel>
          <Panel
            title={<Label style={StyledPanelTitle}>Border</Label>}
            initiallyClosed
            icon={Arrow}
          >
            <Border
              data-test-id="border-data"
              updateBorderData={updateBorderData}
              disabled={layoutLocked}
              handleLineColor={handleLineColor}
              widgetState={widgetState}
              pages={props.pages}
              site={props.site}
              updateSite={props.updateSite}
              saveSite={props.saveSite}
            />
          </Panel>
        </StyledPanel>
      </Panel.Group>
    </>
  );
};

export default DropdownWidgetControl;
